export class Nomenclature {
  constructor() { }

  goodId: number
  numberOfRow: number
  name: string
  nmc: number
  count: number
  priceKp: number
  summKp: number
  pl: number
  sp: number
  gr: number
  sb: number
  marge: number
  status: string
  rowColor: string
  goodDetails: string
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/nomenclature.ts